module.exports = __webpack_public_path__ + "media/images/background_04-a60973072c6b8c0a14433f636d668716.jpg";